import {
  Card,
  CardActionArea,
  Stack,
  IconButton,
  Typography,
  CardContent,
  Button,
  useMediaQuery,
  useTheme,
} from "@mui/material"
import Image from "components/Image"
import React, { useCallback } from "react"
import { useTranslation } from "react-i18next"
import { styles } from "./styles/GameItem.styles"
import { maxWidth600 } from "themes/default/breakpoints"
import { select } from "utils/sounds"
import useSound from "use-sound"
import { MODAL_VARIENTS } from "./ChooseGameModal"
import { useAuthContext } from "contexts/AuthContext"
import { useThemeContext } from "contexts/ThemeContext"

export default function GameItem({
  title,
  image,
  onClick,
  onHover = () => {},
  variant = "default",
}) {
  const { t } = useTranslation()
  const { audioSettings } = useAuthContext()
  const [playSelect] = useSound(select, {
    volume: 0.5,
    soundEnabled: audioSettings?.enabledAudioEffects,
    html5: false,
  })
  const { fontSize } = useThemeContext()
  const matches = useMediaQuery(maxWidth600)
  const itemWidth = matches ? 70 : 90
  const theme = useTheme()

  const onItemClick = useCallback(() => {
    playSelect()
    if (onClick) {
      onClick()
    }
  }, [onClick, playSelect])

  return (
    <Card
      sx={[styles.item, variant === MODAL_VARIENTS.SIMPLE && styles.itemSimple]}
    >
      <CardActionArea
        onClick={onItemClick}
        onMouseEnter={onHover}
        sx={[styles.hoverButton, { height: "100%" }]}
      >
        <CardContent sx={styles.itemContent}>
          <IconButton sx={[styles.hoverButton, styles.gameItem]} disableRipple>
            <Stack justifyContent={"center"} alignItems={"center"}>
              <Image
                name={image}
                wrapperClassName="icon"
                width={itemWidth}
                height={itemWidth}
              />
              <Image
                name={`${image}Active`}
                wrapperClassName="active-icon"
                width={itemWidth}
                height={itemWidth}
              />
            </Stack>
          </IconButton>
          <Stack mt={variant === MODAL_VARIENTS.SIMPLE ? 0 : "10%"}>
            <Typography
              variant="span"
              color={theme.palette.common.black}
              fontSize={parseInt(fontSize?.replace("px", "")) - 4}
              textTransform={"capitalize"}
              textOverflow={"ellipsis"}
              overflow={"hidden"}
            >
              {t(title)}
            </Typography>
          </Stack>
          {variant === MODAL_VARIENTS.DEFAULT && (
            <Button
              variant="contained"
              disableElevation
              sx={styles.startButton}
              onClick={onItemClick}
            >
              <Typography
                variant="span"
                fontSize={parseInt(fontSize?.replace("px", "")) - 4}
                sx={{
                  textTransform: "none",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  color: theme.palette.common.white,
                }}
              >
                {t("Select")}
              </Typography>
            </Button>
          )}
        </CardContent>
      </CardActionArea>
    </Card>
  )
}
